import React from "react";
import { Icon } from "lib";

function SelectionModalColumnLoader() {
  return (
    <div className="flex min-h-0 flex-col flex-grow justify-center items-center">
      <Icon name="loader" />
    </div>
  );
}

export default SelectionModalColumnLoader;
